const GENERAL_COMMANDS = ['/color', '/gender', '/help', '/mute', '/online'];

const FREE_EMOTES = [
  '/applaud',
  '/bow',
  '/cackle',
  '/cheer',
  '/clap',
  '/cower',
  '/cry',
  '/dance',
  '/eyeroll',
  '/flex',
  '/giggle',
  '/glance',
  '/glare',
  '/grit',
  '/headshake',
  '/hug',
  '/laugh',
  '/lol',
  '/nod',
  '/point',
  '/poke',
  '/scratch',
  '/scream',
  '/shrug',
  '/sigh',
  '/smile',
  '/snicker',
  '/tap',
  '/taunt',
  '/wave',
  '/wink',
  '/yawn',
];

module.exports = {
  GENERAL_COMMANDS,
  FREE_EMOTES,
};
